/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Templatesroles_ReadInputs */

const en_enum_permission_name_templatesroles_read = /** @type {(inputs: Enum_Permission_Name_Templatesroles_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templatesroles Read`)
};

const de_enum_permission_name_templatesroles_read = /** @type {(inputs: Enum_Permission_Name_Templatesroles_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templatesroles Read`)
};

/**
* | output |
* | --- |
* | "Templatesroles Read" |
*
* @param {Enum_Permission_Name_Templatesroles_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_templatesroles_read = /** @type {((inputs?: Enum_Permission_Name_Templatesroles_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Templatesroles_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_templatesroles_read(inputs)
	return de_enum_permission_name_templatesroles_read(inputs)
});